export default __webpack_public_path__ + "static/media/lena.791d611d.jpg";